import React from 'react'
import Sticky from 'react-sticky-fill'

import PageHeader from '@components/PageHeader/PageHeader'

export default function PageHeaderSticky({ top='50px', ...props }) {
	return (
		<Sticky style={{top}}>
			<PageHeader {...props} />
		</Sticky>
	);
}


// WEBPACK FOOTER //
// ./src/components/PageHeaderSticky/PageHeaderSticky.jsx